import { Wallet, MessageCircle, ArrowRight } from "lucide-react";

export default function Hero({ onContact }) {
    return (
        <section
            data-testid="hero-section"
            className="mx-auto w-full max-w-2xl px-4 pt-10 pb-12 text-center md:px-6 md:pt-14 md:pb-16"
        >
            <span
                data-testid="hero-badge"
                className="inline-flex items-center rounded-full border border-[#D4AF37]/40 bg-[#101010] px-4 py-1.5 text-[11px] font-bold tracking-[0.28em] text-[#FFD76A]"
            >
                VIRAT WORKHUB
            </span>

            <h1
                data-testid="hero-heading"
                className="font-heading mt-5 font-black leading-[1.05] tracking-[-0.02em]"
            >
                <span
                    data-testid="hero-heading-line-1"
                    className="block text-white text-[clamp(36px,10.5vw,60px)]"
                >
                    INSTAGRAM REEL
                </span>
                <span
                    data-testid="hero-heading-line-2"
                    className="text-gold-metallic block whitespace-nowrap text-[clamp(31px,9.2vw,54px)]"
                >
                    UPLOADING WORK
                </span>
            </h1>

            <p
                data-testid="hero-subtitle"
                className="mt-4 text-base font-bold text-[#FFD76A] md:text-lg"
            >
                Work From Home • Weekly Payments
            </p>

            <p
                data-testid="hero-description"
                className="mx-auto mt-3 max-w-md text-base leading-[1.6] text-[#B5B5B5] md:text-[17px]"
            >
                Upload assigned Instagram reels according to instructions and explore flexible
                work opportunities with Virat WorkHub.
            </p>

            <div
                data-testid="earnings-card"
                className="relative mt-8 overflow-hidden rounded-2xl border border-[#D4AF37]/40 bg-[#101010] p-6 shadow-[0_4px_24px_rgba(212,175,55,0.12)] md:p-8"
            >
                <div
                    aria-hidden="true"
                    className="pointer-events-none absolute -top-20 left-1/2 h-40 w-56 -translate-x-1/2 rounded-full bg-[#D4AF37]/10 blur-3xl"
                />
                <Wallet
                    className="relative mx-auto h-8 w-8 text-[#D4AF37]"
                    strokeWidth={1.8}
                    aria-hidden="true"
                />
                <p
                    data-testid="earnings-label"
                    className="relative mt-3 text-[11px] font-bold tracking-[0.25em] text-[#FFD76A]"
                >
                    POTENTIAL WEEKLY EARNINGS
                </p>
                <p
                    data-testid="earnings-amount"
                    className="font-heading relative mt-2 text-[30px] font-extrabold leading-tight text-white md:text-4xl"
                >
                    ₹6,000–₹8,000
                    <span className="whitespace-nowrap text-[#D4AF37]"> / Week</span>
                </p>
                <p
                    data-testid="earnings-disclaimer"
                    className="relative mx-auto mt-3 max-w-sm text-xs leading-relaxed text-[#B5B5B5]"
                >
                    Potential earnings depend on completed work, approval, availability, and
                    applicable conditions.
                </p>
            </div>

            <div className="mt-7">
                <button
                    type="button"
                    data-testid="main-cta-button"
                    onClick={onContact}
                    className="btn-gold-gradient flex h-[58px] w-full items-center justify-between rounded-full px-6 text-[16px] font-bold text-[#1A1405] shadow-[0_4px_24px_rgba(212,175,55,0.3)] transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-[0_8px_32px_rgba(212,175,55,0.4)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FFD76A] focus-visible:ring-offset-2 focus-visible:ring-offset-[#050505] md:text-[17px]"
                >
                    <MessageCircle className="h-5 w-5" strokeWidth={2.2} aria-hidden="true" />
                    <span>Contact Us to Get Started</span>
                    <ArrowRight className="h-5 w-5" strokeWidth={2.2} aria-hidden="true" />
                </button>
                <p
                    data-testid="main-cta-subtext"
                    className="mt-3 text-sm text-[#B5B5B5]"
                >
                    Our team is available through Telegram and WhatsApp.
                </p>
            </div>
        </section>
    );
}
